export const comparableTransactionConstants = {
  COMPARABLE_TRANSACTION_CREATE_LOADING: 'COMPARABLE_TRANSACTION_CREATE_LOADING',
  COMPARABLE_TRANSACTION_CREATE_SUCCESS: 'COMPARABLE_TRANSACTION_CREATE_SUCCESS',
  COMPARABLE_TRANSACTION_CREATE_FAILURE: 'COMPARABLE_TRANSACTION_CREATE_FAILURE',
  COMPARABLE_TRANSACTION_ERROR_RELOAD: 'COMPARABLE_TRANSACTION_ERROR_RELOAD',

  COMPARABLE_TRANSACTION_LIST_LOADING: 'COMPARABLE_TRANSACTION_LIST_LOADING',
  COMPARABLE_TRANSACTION_LIST_SUCCESS: 'COMPARABLE_TRANSACTION_LIST_SUCCESS',
  COMPARABLE_TRANSACTION_LIST_FAILURE: 'COMPARABLE_TRANSACTION_LIST_FAILURE',

  COMPARABLE_TRANSACTION_EDIT_LOADING: 'COMPARABLE_TRANSACTION_EDIT_LOADING',
  COMPARABLE_TRANSACTION_EDIT_SUCCESS: 'COMPARABLE_TRANSACTION_EDIT_SUCCESS',
  COMPARABLE_TRANSACTION_EDIT_FAILURE: 'COMPARABLE_TRANSACTION_EDIT_FAILURE',

  COMPARABLE_TRANSACTION_DELETE_LOADING: 'COMPARABLE_TRANSACTION_DELETE_LOADING',
  COMPARABLE_TRANSACTION_DELETE_SUCCESS: 'COMPARABLE_TRANSACTION_DELETE_SUCCESS',
  COMPARABLE_TRANSACTION_DELETE_FAILURE: 'COMPARABLE_TRANSACTION_DELETE_FAILURE'
};
